import { Observable, of } from 'rxjs';
import { Loader, LoaderType } from '../utils/loader.util';
import { mergeMap, finalize, tap } from 'rxjs/operators';

export const trackExecutionHttp = <T>(type: LoaderType, loader: Loader = Loader.instance) => (source: Observable<T>) => {
  const observable = new Observable<T>((observer) => {

    const wrapSource = of({}).pipe(
      tap(() =>  loader.lock(type)),
      mergeMap(() => source),
      finalize(() => loader.unlock(type)),
    );

    const unsubcribe = wrapSource.subscribe({
      next(x) { observer.next(x); },
      error(error) { observer.error(error); },
      complete() { observer.complete(); },
    });
    return unsubcribe;
  });
  return observable;
}